<template>
  <el-container class="myContainer">
    <el-aside width="400px" class="myContainer">
      <el-card class="box-card">
        <el-tree :data="departmentData" :props="defaultProps" node-key="id"
                 @node-click="nodeClickHandle"
                 default-expand-all highlight-current ref="active"
                 :expand-on-click-node="false" class="department-tree">

          <template #default="{ node, data }">
            <el-row style="width:100%;line-height: 32px" :gutter="0">
              {{ node.label }}
              <div v-if="currentDepartment.id == data.id" style="position: absolute;right: 0">
                <FrameButton v-if="data.level < 7" :key="data.id" :button="addButton" :parentData="data"></FrameButton>
                <FrameButton :key="data.id" :button="editButton" :parentData="data"></FrameButton>
                <FrameButton v-if="data.level == 0" :key="data.id" :button="impButton"></FrameButton>
              </div>
            </el-row>
          </template>

        </el-tree>

      </el-card>

    </el-aside>
    <el-main class="myContainer">

      <el-card class="box-card">
        <template #header>
          <div class="card-header">
            <span width="100%" class="department-name">部门：{{ currentDepartment.name }}</span>
          </div>
        </template>
        <div>
          <frame-query
              ref="frameQuery"
              componentParam="sys_user"
              :parent-data="queryParam"
          ></frame-query>
        </div>
      </el-card>

    </el-main>
  </el-container>
</template>

<script>

export default {
  name: "User",
  props: {
    componentParam: {
      type: String,
      required: true
    }
  },
  computed: {
    queryParam() {
      return {
        department_id: this.currentDepartment.id
      }
    }
  },
  provide() {
    return {
      $fn: {
        reloadTreeData: () => {
          this.loadDirTree();
        }
      }
    }
  },
  data() {
    return {
      addButton: {
        "component": "button",
        "text": true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-CirclePlus",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "sys_department_add", "title": "添加部门", "width": 800, "height": 600}
      },
      editButton: {
        "component": "button",
        "text": true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-Edit",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "sys_department_edit", "title": "编辑部门", "width": 800, "height": 600}
      },
      impButton: {
        "component": "button",
        "text": true,
        "circle": true,
        "icon_only": true,
        "icon": "el-icon-Grid",
        "click": "jsOpenDialog",
        "window": {"component": "frame/FrameForm", "type": "sys_department_import", "title": "导入部门", "width": 800, "height": 600}
      },
      addData: {parentId: '', name: '', leadDepartmentUserIds: ''},
      departmentData: [],
      userData: [],
      currentDepartment: {id:"ROOT"},
      subPage: 'user',
      editData: {id: '', oldName: '', name: '', leadDepartmentUserIds: ''},
      defaultProps: {
        children: 'children',
        label: 'name_with_leader',
      }
    }
  },
  methods: {
    //--勾选--
    nodeClickHandle(currentRow) {
      var rootDep = {id:"ROOT"}
      if(!currentRow || !currentRow.id){
        this.currentDepartment = rootDep;
      }else{
        this.currentDepartment = currentRow;
      }

      this.$refs.frameQuery.search();
      //this.$refs.frameQuery.initForm()
    },
    async loadDirTree() {
      let data = await this.$http('sysDepartmentService.getRootTree');
      this.departmentData = data || [];
    }
  },
  created() {
    this.loadDirTree();
  }
}
</script>

<style lang="less" scoped>
@import 'src/global';

.myContainer {
  padding: 5px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.department-name {
  font-size: @fontSizeXX;
}

.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.departmentBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.departmentLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.departmentRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.treeIcon {
  margin-right: 10px
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.departmentUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}

.departmentTitle {
  height: 45px !important;
  line-height: 40px;
  font-size: @fontSizeSS;
}

.departmentName {
  white-space: nowrap;
  min-width: 120px;
  margin-right: 30px;
  padding-right: 20px;
  font-size: @fontSizeS;
}

.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.departmentEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.departmentTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDepartment {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}
</style>
<style lang="less">
@import '@/global';

.rightTree > .el-tree-node > .el-tree-node__children {
  display: flex;
  flex-direction: row !important;
}

.rightTree > .el-tree-node > .el-tree-node__content {
  height: 40px;
}

.rightTree > .el-tree-node > .el-tree-node__content > .el-tree-node__label {
  font-size: @fontSizeS;
}

.departmentPoper {
  padding: 0 !important;
}

.poperItem {
  color: #409EFF;
  padding: 0 10px;
  height: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.poperItem:hover {
  background: whitesmoke;
}

.textDepartment {
  font-size: medium;
}
</style>

<style scoped>
.el-tree >>> .el-tree-node__content {
  height: 36px;
}

.department-tree {
  min-height: 600px;
  overflow-y: auto;
}
</style>
